import { Routes } from '@angular/router';
import { ErrorComponent } from './error/error.component';
import { DashboardGuard } from './guards/dashboard.guard';
import { NotDashboardGuard } from './guards/not-dashboard.guard';
import { TelemetryViewerGuard } from './guards/telemetry-viewer.guard';
import { LoginComponent } from './login/login.component';

export const ROUTES: Routes = [
  {
    path: '', component: LoginComponent,
    canActivate: [NotDashboardGuard]
  },
  {
    path: 'login', loadComponent: () => import('./login/login.component').then(m => m.LoginComponent), canActivate: [NotDashboardGuard]
  },
  {
    path: 'registry', loadComponent: () => import('../modules/auth/registry/registry.view').then(m => m.RegistryView), canActivate: [NotDashboardGuard]
  },
  {
    path: 'register', redirectTo: 'registry', pathMatch: 'full'
  },
  {
    path: 'forgot-password', loadComponent: () => import('./login/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent), canActivate: [NotDashboardGuard]
  },
  {
    path: 'email-confirmation', loadComponent: () => import('../modules/auth/registry/views/email-confirmation/email-confirmation.view').then(m => m.EmailConfirmationView)
  },
  {
    path: 'recompensa',
    loadComponent: () => import('./incentives/recompensa-publica/recompensa-publica.component').then(m => m.RecompensaPublicaComponent)
  },
  {
    path: 'customer-tracking',
    loadComponent: () => import('./customer-tracking/customer-tracking.component').then(m => m.CustomerTrackingComponent)
  },
  {
    path: 'customer-claim-account',
    loadComponent: () => import('./customer-tracking/customer-claim-account.component').then(m => m.CustomerClaimAccountComponent)
  },
  {
    path: 'test-tracking',
    loadComponent: () => import('../modules/drayage/tracking/components/tracking-map/tracking-map.component').then(m => m.TrackingMapComponent),
  },
  {
    path: 'reset', loadComponent: () => import('./login/resetpassword/resetpassword.component').then(m => m.ResetpasswordComponent), canActivate: [NotDashboardGuard]
  },
  {
    path: 'maintenance', loadComponent: () => import('./login/maintenance/maintenance.component').then(m => m.MaintenanceComponent)
  },
  {
    path: 'financing/authorize', loadComponent: () => import('../modules/financing/authorize/financing-authorize.view').then(m => m.FinancingAuthorizeView)
  },
  {
    path: 'app', loadChildren: () => import('./layout/layout.module').then(m => m.LayoutModule), canActivate: [DashboardGuard]
  },
  {
    path: 'faq', loadChildren: () => import('./f-a-q/faq.module').then(m => m.FaqModule),
  },
  {
    // Catálogo de la biblioteca. Sin guardia a propósito: una referencia de
    // diseño no debería exigir iniciar sesión para consultarse.
    path: 'ui-kit', loadComponent: () => import('./ui-kit/ui-kit.component').then(m => m.UiKitComponent)
  },
  {
    // Un espécimen solo, a la anchura del iframe que lo pinta: las primitivas
    // responden a `@media` del viewport y un `<div>` estrecho no las dispara.
    // Mismo componente y misma carga perezosa; ver `<kit-spec [widths]>`.
    path: 'ui-kit/frame/:spec', loadComponent: () => import('./ui-kit/ui-kit.component').then(m => m.UiKitComponent)
  },
  {
    // Telemetría de uso: solo superadmin, con su sesión o entrando como otro usuario. Fuera del
    // marco a propósito: entrando como un cliente, el marco sería el del cliente.
    path: 'telemetry', canActivate: [DashboardGuard, TelemetryViewerGuard],
    loadComponent: () => import('./telemetry/telemetry.component').then(m => m.TelemetryComponent)
  },
  {
    path: 'error', component: ErrorComponent
  },
  {
    path: '**', component: ErrorComponent
  }
];
